/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetMedicinesResponseDto,
  MedicineResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetMedicinesResponseDtoFromJSON,
    GetMedicinesResponseDtoToJSON,
    MedicineResponseDtoFromJSON,
    MedicineResponseDtoToJSON,
} from '../models/index';

export interface GetMedicineByCodeRequest {
    code: string;
}

export interface GetMedicineByIdRequest {
    id: string;
}

export interface GetMedicinesRequest {
    search?: string;
    categoryName?: string;
    code?: string;
    page?: number;
    pageSize?: number;
}

export interface MedicineControllerUploadMedicineJsonRequest {
    file?: Blob;
}

/**
 * 
 */
export class MedicineApi extends runtime.BaseAPI {

    /**
     * Retrieve a single medicine by its code
     * Get medicine by code
     */
    async getMedicineByCodeRaw(requestParameters: GetMedicineByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicineResponseDto>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling getMedicineByCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/medicine/code/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicineResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve a single medicine by its code
     * Get medicine by code
     */
    async getMedicineByCode(requestParameters: GetMedicineByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicineResponseDto> {
        const response = await this.getMedicineByCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a single medicine by its ID
     * Get medicine by ID
     */
    async getMedicineByIdRaw(requestParameters: GetMedicineByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicineResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMedicineById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/medicine/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicineResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve a single medicine by its ID
     * Get medicine by ID
     */
    async getMedicineById(requestParameters: GetMedicineByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicineResponseDto> {
        const response = await this.getMedicineByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a paginated list of medicines with optional search and filters
     * Get list of medicines with pagination
     */
    async getMedicinesRaw(requestParameters: GetMedicinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicinesResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['categoryName'] != null) {
            queryParameters['categoryName'] = requestParameters['categoryName'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/medicine`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicinesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve a paginated list of medicines with optional search and filters
     * Get list of medicines with pagination
     */
    async getMedicines(requestParameters: GetMedicinesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicinesResponseDto> {
        const response = await this.getMedicinesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a JSON file containing medicine data. The data will be parsed and inserted directly into the database.
     * Upload medicine JSON file and import to database
     */
    async medicineControllerUploadMedicineJsonRaw(requestParameters: MedicineControllerUploadMedicineJsonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/admin/medicine/upload-json`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload a JSON file containing medicine data. The data will be parsed and inserted directly into the database.
     * Upload medicine JSON file and import to database
     */
    async medicineControllerUploadMedicineJson(requestParameters: MedicineControllerUploadMedicineJsonRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.medicineControllerUploadMedicineJsonRaw(requestParameters, initOverrides);
    }

}
